export default __webpack_public_path__ + "static/media/Country Roads [Whisper of the Heart] (John Denver) With lyrics.676134c3.mp3";